import { ClientInfo } from './types';

/**
 * Service class for client management
 */
export class AuditService {
  private clients: ClientInfo[];

  constructor() {
    // Initialize with sample data
    this.clients = this.generateSampleClients();
  }

  // Get all clients
  getClients(): ClientInfo[] {
    return this.clients;
  }

  // Get client by ID
  getClientById(clientId: string): ClientInfo | undefined {
    return this.clients.find(client => client.id === clientId);
  }

  // Get client full name
  getClientFullName(client: ClientInfo): string {
    return `${client.name} ${client.firstSurname} ${client.secondSurname}`;
  }

  // Generate 15 sample clients
  private generateSampleClients(): ClientInfo[] {
    return [
      {
        id: 'client-1',
        name: 'Carlos',
        firstSurname: 'Rodríguez',
        secondSurname: 'García',
        email: 'carlos.rodriguez@example.com',
        phoneNumber: '+34 612 345 678'
      },
      {
        id: 'client-2',
        name: 'Ana',
        firstSurname: 'Martínez',
        secondSurname: 'López',
        email: 'ana.martinez@example.com',
        phoneNumber: '+34 623 456 789'
      },
      {
        id: 'client-3',
        name: 'Miguel',
        firstSurname: 'Fernández',
        secondSurname: 'Sánchez',
        email: 'miguel.fernandez@example.com',
        phoneNumber: '+34 634 567 890'
      },
      {
        id: 'client-4',
        name: 'Laura',
        firstSurname: 'Sánchez',
        secondSurname: 'Pérez',
        email: 'laura.sanchez@example.com',
        phoneNumber: '+34 645 678 901'
      },
      {
        id: 'client-5',
        name: 'Javier',
        firstSurname: 'López',
        secondSurname: 'Martín',
        email: 'javier.lopez@example.com',
        phoneNumber: '+34 656 789 012'
      },
      {
        id: 'client-6',
        name: 'Carmen',
        firstSurname: 'Navarro',
        secondSurname: 'Ruiz',
        email: 'carmen.navarro@example.com',
        phoneNumber: '+34 667 890 123'
      },
      {
        id: 'client-7',
        name: 'David',
        firstSurname: 'Moreno',
        secondSurname: 'González',
        email: 'david.moreno@example.com',
        phoneNumber: '+34 678 901 234'
      },
      {
        id: 'client-8',
        name: 'Sofía',
        firstSurname: 'González',
        secondSurname: 'Rodríguez',
        email: 'sofia.gonzalez@example.com',
        phoneNumber: '+34 689 012 345'
      },
      {
        id: 'client-9',
        name: 'Alejandro',
        firstSurname: 'Torres',
        secondSurname: 'Hernández',
        email: 'alejandro.torres@example.com',
        phoneNumber: '+34 690 123 456'
      },
      {
        id: 'client-10',
        name: 'Isabel',
        firstSurname: 'Herrera',
        secondSurname: 'Díaz',
        email: 'isabel.herrera@example.com',
        phoneNumber: '+34 701 234 567'
      },
      {
        id: 'client-11',
        name: 'Pablo',
        firstSurname: 'Vargas',
        secondSurname: 'Morales',
        email: 'pablo.vargas@example.com',
        phoneNumber: '+34 712 345 678'
      },
      {
        id: 'client-12',
        name: 'Lucía',
        firstSurname: 'Ramírez',
        secondSurname: 'Jiménez',
        email: 'lucia.ramirez@example.com',
        phoneNumber: '+34 723 456 789'
      },
      {
        id: 'client-13',
        name: 'Antonio',
        firstSurname: 'Serrano',
        secondSurname: 'Romero',
        email: 'antonio.serrano@example.com',
        phoneNumber: '+34 734 567 890'
      },
      {
        id: 'client-14',
        name: 'María',
        firstSurname: 'Ortiz',
        secondSurname: 'Blanco',
        email: 'maria.ortiz@example.com',
        phoneNumber: '+34 745 678 901'
      },
      {
        id: 'client-15',
        name: 'Roberto',
        firstSurname: 'Castillo',
        secondSurname: 'Alonso',
        email: 'roberto.castillo@example.com',
        phoneNumber: '+34 756 789 012'
      }
    ];
  }
}

// Export singleton for global use
export const auditService11 = new AuditService();
